<script>
    import {
        Block,
        BlockTitle,
        List,
        ListInput,
        Row,
        Col,
        Button,
        Link,
        Chip,
        Tabs,
        Tab
    } from 'framework7-svelte';
    import { onMount } from 'svelte';
    import { getAlertas,getContacto } from '../../../tools/service/general'
    let showMsgAlert=false
    let txtMsgSend='-------------------'
    let showMsgSend = false
    $: validateOnBlur = true
    let contacto={
        "nombre":"",
        "institucion":"",
        "correo":"",
        "correoCheck":"",
        "comentario":""
    }
    let validate = {
        "nombre":{error:false,status:false},
        "institucion":{error:false,status:false},
        "correo":{error:false,status:false},
        "correoCheck":{error:false,status:false,msg:''}
    }
    function checkStatus(param){
        let status=true;
        if(contacto.correoCheck !=""){
            validateOnBlur = true
        }
        for (const property in param) {
            if(!param[property]['status']){

                status = false
                contacto[property] = null
                validate.correoCheck.error=true
            }
        }

        if(!status){showAlert()}
        return status
    }
    function showAlert(){
            showMsgAlert=true
            validateOnBlur=false
        setTimeout(function(){
            showMsgAlert=false
            validateOnBlur=true
        }, 3000);
    }
    function showSend(){
            showMsgSend=true
            for (const property in contacto) {
                contacto[property] = ""
            }
            for (const property in validate) {
                validate[property]['error'] = false
                validate[property]['status'] = false
            }            
        setTimeout(function(){
            showMsgSend=false

        }, 4000);
    }
</script>
{#if !showMsgSend}
    <Block>
        <p>
        </p>
        <strong>
        Dudas, reporte de fallas, comentarios o sugerencias
        </strong>
        <strong>
            <p style="margin-top: 25px;color: var(--f7-table-footer-text-color);font-size: var(--f7-table-footer-font-size);">
                La información personal proporcionada es sólo para fines estadísticos y sigue las políticas de privacidad y protección de datos de la Conabio.
                <Link style="margin-top: 15px;"
                iconSize="18px"
                tooltip="{`
                    <span style="color:white">Aviso de privacidad</span>
                `}"
                iconIos="f7:info_circle_fill" iconAurora="f7:info_circle_fill" iconMd="f7:info_circle_fill"
                on:click={()=>{
                    window.open("https://www.biodiversidad.gob.mx/conabio/proteccion-DP/ap-proteccion-datos","","titlebar=no");
                }}/>
            </p>
            <p>
        <Link href="https://docs.google.com/forms/d/e/1FAIpQLScmY6Ah-9m-cJ49sofLfXLezQUk8K3JwiJQNXAA22V2tG69Kw/viewform?usp=header" target="_blank" external>
            <img src="static/png/contacto_registro.png" alt="Registro de Usuarios" width="595px;"/>
        </Link>
            </p>
        </strong>        
        <!-- <List inlineLabels noHairlinesMd>
            <ListInput
            label="Nombre"
            type="text"
            bind:value={contacto.nombre}
            placeholder="Ingresa el nombre"
            required
            validate
            errorMessage="Completa este campo"
            errorMessageForce={validate.nombre.error}
            onInput={() => validate.nombre.error = false }
            onValidate={(isValid) => validate.nombre.status=isValid}
            clearButton
            >
            </ListInput>
            <ListInput
            label="Institución"
            type="text"
            bind:value={contacto.institucion}
            required
            validate
            errorMessage="Completa este campo"
            errorMessageForce={validate.institucion.error}
            onInput={() => validate.institucion.error = false }
            onValidate={(isValid) => validate.institucion.status=isValid}
            placeholder="Ingresa la institución"
            clearButton
            >
            </ListInput>
            <ListInput
            label="Correo"
            type="email"
            bind:value={contacto.correo}
            required
            validate
            errorMessage="Completa este campo"
            errorMessageForce={validate.correo.error}
            onInput={() => validate.correo.error = false }
            onValidate={(isValid) => validate.correo.status=isValid}
            placeholder="Ingresa el correo"
            clearButton
            >
            
            </ListInput>
            <ListInput
            label="Confirmar Correo"
            type="email"
            bind:value={contacto.correoCheck}
            required
            validate
            errorMessage={validate.correoCheck.msg}
            errorMessageForce={validate.correoCheck.error}
            onInput={(val) => {
                validate.correoCheck.error = false
                }}
            validateOnBlur={validateOnBlur}
            onBlur={(val) => {
                    validate.correoCheck.error = false
                    validate.correoCheck.msg=""

                    if(contacto.correo!==contacto.correoCheck){
                        validate.correoCheck.error = true
                        validate.correoCheck.msg="correo no coincide"
                    }
                }}
            onValidate={(isValid) => validate.correoCheck.status=isValid}
            placeholder="Ingresa el correo"
            clearButton
            >
            </ListInput>
            <ListInput
            label="Mensaje"
            type="textarea"
            placeholder="Escriba su mensaje..."
            bind:value={contacto.comentario}
            clearButton
            >
            </ListInput>
        </List> -->
    </Block>
    <Block>
        {#if showMsgAlert}
        <Row style="text-align: center;">               
            <Col >
                <Chip text="Por favor ingresa los datos faltantes" color="red" />    
            </Col>
        </Row>
        {:else}
        <Row>
            <Col>
            </Col>
            <Col>
            <!-- <Button outline
            on:click={async ()=>{
                let result={}
                if(checkStatus(validate)){
                    result = await getContacto(contacto)
                    txtMsgSend=result.msg
                    showSend()
                }
            }}
            >Enviar</Button> -->
            </Col>
            <Col>
            </Col>
        </Row>
        {/if}
    </Block>
    <Block>
        <p>La información proporcionada por esta vía será enviada directamente al equipo de Alerta Temprana de Incendios de la Conabio.</p>
    </Block>
    {:else}
        <BlockTitle> Mensaje Enviado </BlockTitle>
        <Block>
            <Row>               
                <Col>
                    <p>{txtMsgSend}</p>    
                </Col>
            </Row>
        </Block>

    {/if}
